const ArrowChevron = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M6 11.7695C6.00573 11.5969 6.04011 11.4382 6.10315 11.2935C6.17192 11.1487 6.27507 11.0095 6.41261 10.8759L13.0315 4.5869C13.2493 4.37532 13.5158 4.26953 13.8309 4.26953C14.0487 4.26953 14.2436 4.31964 14.4155 4.41987C14.5931 4.52009 14.7335 4.6565 14.8367 4.82911C14.9456 4.99615 15 5.18267 15 5.38868C15 5.70049 14.8797 5.97332 14.639 6.20717L8.75072 11.7695L14.639 17.3319C14.8797 17.5713 15 17.8441 15 18.1504C15 18.362 14.9456 18.5513 14.8367 18.7183C14.7335 18.8853 14.5931 19.019 14.4155 19.1192C14.2436 19.2194 14.0487 19.2695 13.8309 19.2695C13.5158 19.2695 13.2493 19.1637 13.0315 18.9522L6.41261 12.6632C6.26934 12.5296 6.16332 12.3904 6.09456 12.2456C6.03152 12.0953 6 11.9366 6 11.7695Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default ArrowChevron;
